import {
    Table,
    TableContainer,
    Tbody,
    Td,
    Th,
    Thead,
    Tr,
} from '@chakra-ui/react';
import { useState, useEffect } from 'react';
import { FaEdit } from 'react-icons/fa';
import { MdDelete } from 'react-icons/md';
import { PiWarningCircleBold } from 'react-icons/pi';

import * as React from 'react';
import { IoMdAdd } from 'react-icons/io';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Dropdown, Form } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import ReactPaginate from 'react-paginate';
import { FiPlusCircle } from "react-icons/fi";
import { MdOutlineDeleteOutline } from "react-icons/md";
import { VscTarget } from "react-icons/vsc";
import { IoSearchOutline } from 'react-icons/io5';
import {
    partyDropdown,
    productDropdown,
    searchHsn,
} from '../../../redux/actions/Master.action';
import { Formik, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { addPurchaseBill, deletePurchaseBill, getPurchaseBill, updatePurchaseBill, verifyOtp, viewPurchaseBill } from '../../../redux/actions/Billing.action';
import { toast } from 'react-toastify';
import { useRef } from 'react';

export default function PurchaseBill() {
    const [show, setShow] = useState(false);
    const [viewModal, setViewModal] = useState(false);
    const [updateModal, setUpdateModal] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);
    const [otpModel, setOtpModel] = useState(false);
    const [ids, setIds] = useState(null);
    const [searchProduct, setSearchProduct] = useState('');
    const [searchParty, setSearchParty] = useState('');
    const dropdownRefs = useRef([]);
    const inputRefs = useRef({
        batchNo: null,
        expDate: null,
        fn: null,
        fQty: null,
        pRate: null,
        discount: null,
        qty: null
    });
    const [isProductSelected, setIsProductSelected] = useState(false);
    const [mainPage, setMainPage] = useState('1');
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [searchQuery, setSearchQuery] = useState('');
    const [searchDefault, setSearchDefault] = useState({
        page: '',
        search: '',
    });

    const [initialValues, setInitialValues] = useState({
        partyId: '',
        billNo: '',
        billDate: '',
    });

    const validationSchema = Yup.object().shape({
        partyId: Yup.string().required('Party Name is required'),
        billNo: Yup.string().required('Bill No is required'),
        billDate: Yup.string().required('Bill Date is required'),
    });


    const validationOtpSchema = Yup.object().shape({
        otp: Yup.string().required('OTP is required'),
    });


    const [isUpdateMode, setIsUpdateMode] = useState(false)
    const toggle = () => {
        setShow(!show);
    };
    const viewToggle = () => {
        setViewModal(!viewModal);
    };

    const updateToggle = () => {
        setUpdateModal(!updateModal);
        setIsUpdateMode(true)
        setFormData({
            partyId: '',
            taxType: '',
            gstApply: '',
            invoiceType: '',
            billNo: '',
            billDate: '',
            productList: [
                {
                    productName: '',
                    productId: '',
                    discount: '',
                    hsnCode: '',
                    pack: '',
                    mrp: '',
                    batchNo: '',
                    expDate: '',
                    qty: '',
                    fn: '',
                    fQty: '',
                    pRate: '',
                    netRate: '',
                    amount: '',
                    inRate: '',
                    gst: '',
                }
            ],
            cDiscount: '',
            remark: '',
            basicAmount: 0,
            sgst: 0,
            cgst: 0,
            discountAmount: 0,
            offerAmount: 0,
            roundingAmount: 0,
            billAmount: 0
        })

    };
    const deleteToggle = () => {
        setDeleteModal(!deleteModal);
    };

    const deleteOtpToggle = () => {
        setOtpModel(!otpModel);
    };
    const dispatch = useDispatch();
    const purchaseData = useSelector((state) => state.master);
    const billData = useSelector((state) => state.bills);

    const [productList, setProductList] = useState([]);

    const [formData, setFormData] = useState({
        partyId: '',
        taxType: '',
        gstApply: '',
        invoiceType: '',
        billNo: '',
        billDate: '',
        productList: [
            {
                productName: '',
                productId: '',
                discount: '',
                hsnCode: '',
                pack: '',
                mrp: '',
                batchNo: '',
                expDate: '',
                qty: '',
                fn: '',
                fQty: '',
                pRate: '',
                netRate: '',
                amount: '',
                inRate: '',
                gst: '',
            }
        ],
        cDiscount: '',
        remark: '',
        basicAmount: 0,
        sgst: 0,
        cgst: 0,
        discountAmount: 0,
        offerAmount: 0,
        roundingAmount: 0,
        billAmount: 0
    });

    console.log('formData', formData);


    const [calculatedValues, setCalculatedValues] = useState({
        basicAmount: 0,
        sgst: 0,
        cgst: 0,
        discountAmount: 0,
        offerAmount: 0,
        roundingAmount: 0,
        billAmount: 0
    });

    const limits = {
        page: mainPage,
        limit: rowsPerPage,
        search: ''
    };

    const handleDropdownChange = (field, value) => {
        setFormData(prevState => ({
            ...prevState,
            [field]: value,
        }));
    };

    const handleProductSelect = (product, index) => {
        setFormData((prevState) => {
            const updatedProductList = [...prevState.productList];

            updatedProductList[index] = {
                ...updatedProductList[index],
                productName: product?.productName,
                productId: product._id,
                hsnCode: product.hsnCode,
                pack: product.salePack,
                mrp: product.mrp,
                gst: product.gst,
            };

            return {
                ...prevState,
                productList: updatedProductList,
            };
        });

        setIsProductSelected(true);
    };

    const calculateRowFields = (row, fieldName) => {
        const updatedProduct = { ...row };
        const pRate = parseFloat(updatedProduct.pRate) || 0;
        const discount = parseFloat(updatedProduct.discount) || 0;
        const qty = parseFloat(updatedProduct.qty) || 0;
        const fqty = parseFloat(updatedProduct.fQty) || 0;

        if (fieldName === 'pRate' || fieldName === 'discount') {
            updatedProduct.netRate = (pRate - (pRate * discount / 100)).toFixed(2);
        }

        const netRate = parseFloat(updatedProduct.netRate) || 0;
        if (qty) {
            updatedProduct.amount = (qty * netRate).toFixed(2);
        } else {
            updatedProduct.amount = netRate
        }

        const totalQty = qty + fqty;
        const totalAmount = qty * netRate;
        if (qty > 0) {
            updatedProduct.inRate = (totalAmount / totalQty).toFixed(2);
        }
        // when qty is 0 or empty, don't overwrite inRate — let user type it manually
        return updatedProduct;
    };

    const handleFieldChange1 = (field, value, index) => {
        setFormData((prevState) => {
            const updatedProductList = [...prevState.productList];
            const updatedRow = { ...updatedProductList[index], [field]: value };

            const calculatedRow = calculateRowFields(updatedRow, field);
            updatedProductList[index] = calculatedRow;

            const updatedTotals = calculateTotals(
                updatedProductList,
                parseFloat(prevState.cDiscount || 0),
                parseFloat(prevState.offerAmount || 0)
            );

            return {
                ...prevState,
                productList: updatedProductList,
                ...updatedTotals,
            };
        });
    };

    const handleDelete = (index) => {
        const updatedProductList = formData.productList.filter((_, i) => i !== index);

        setFormData((prevState) => {
            calculateTotals(updatedProductList, parseFloat(prevState.cDiscount || 0), parseFloat(prevState.offerAmount || 0));

            return {
                ...prevState,
                productList: updatedProductList,
            };
        });
    };

    const handleProductSelect1 = (selectedProduct, index) => {
        const updatedProductList = [...formData.productList];
        updatedProductList[index] = {
            ...updatedProductList[index],
            productId: selectedProduct._id,
            hsnCode: selectedProduct.hsnCode,
            pack: selectedProduct.salePack,
            mrp: selectedProduct.mrp,
            gst: selectedProduct.gst,
            productName: selectedProduct.productName,
        };

        setFormData({
            ...formData,
            productList: updatedProductList,
        });
    };

    const handleFieldChange = (fieldName, value, index) => {
        setFormData((prevState) => {
            const updatedProductList = [...prevState.productList];

            const updatedProduct = {
                ...updatedProductList[index],
                [fieldName]: value
            };

            updatedProductList[index] = calculateRowFields(updatedProduct, fieldName);
            calculateTotals(updatedProductList, parseFloat(prevState.cDiscount || 0), parseFloat(prevState.offerAmount || 0));

            return {
                ...prevState,
                productList: updatedProductList,
            };
        });
    };

    useEffect(() => {
        if (isProductSelected) {
            if (inputRefs.current.expDate) {
                setTimeout(() => {
                    inputRefs.current.expDate.focus();
                    setIsProductSelected(false);
                }, 100);
            }
        }
    }, [isProductSelected]);

    const handleKeyDown = (fieldName, e) => {
        if (e.key === "Enter") {
            e.preventDefault();

            const fields = ["expDate", "batchNo", "mrp", "qty", "fQty", "fn", "pRate", "discount"];
            const currentIndex = fields.indexOf(fieldName);

            if (fieldName === "discount") {
                handleAddRow();
                return;
            }

            if (currentIndex !== -1 && currentIndex < fields.length - 1) {
                const nextFieldName = fields[currentIndex + 1];
                if (inputRefs.current[nextFieldName]) {
                    inputRefs.current[nextFieldName].focus();
                }
            }
        }
    };

    const handleDeleteRow = (index) => {
        setFormData((prevState) => {
            const updatedProductList = prevState.productList.filter((_, i) => i !== index);
            return {
                ...prevState,
                productList: updatedProductList,
            };
        });
    };

    const calculateTotals = (updatedProductList, discountPercentage = 0, offerAmount = 0) => {
        let basicAmount = 0;
        let totalGST = 0;

        updatedProductList.forEach((product) => {
            const productAmount = parseFloat(product.amount || 0);
            const productGST = (productAmount * parseFloat(product.gst || 0)) / 100;

            basicAmount += productAmount;
            totalGST += productGST;
        });

        const discountAmount = (basicAmount * discountPercentage) / 100;

        const adjustedBasicAmount = basicAmount - discountAmount;

        const sgst = (totalGST / 2).toFixed(2);
        const cgst = (totalGST / 2).toFixed(2);

        const totalWithTaxes = parseFloat(adjustedBasicAmount) + parseFloat(sgst) + parseFloat(cgst);

        const adjustedTotal = totalWithTaxes - offerAmount;

        const nearestInteger = Math.round(adjustedTotal);
        const roundingAmount = (nearestInteger - adjustedTotal).toFixed(2);
        const billAmount = nearestInteger.toFixed(2);

        setCalculatedValues({
            basicAmount: basicAmount.toFixed(2),
            discountAmount: discountAmount.toFixed(2),
            adjustedBasicAmount: adjustedBasicAmount.toFixed(2),
            sgst,
            cgst,
            offerAmount: offerAmount,
            roundingAmount,
            billAmount,
        });
    };

    useEffect(() => {
        if (calculatedValues) {
            setFormData((prev) => ({
                ...prev,
                basicAmount: calculatedValues.basicAmount,
                discountAmount: calculatedValues.discountAmount,
                adjustedBasicAmount: calculatedValues.adjustedBasicAmount,
                sgst: calculatedValues.sgst,
                cgst: calculatedValues.cgst,
                offerAmount: calculatedValues.offerAmount,
                roundingAmount: calculatedValues.roundingAmount,
                billAmount: calculatedValues.billAmount,
            }));
        }
    }, [calculatedValues]);

   const handleAddBill = (values, { resetForm }) => {
        if (!formData.productList.length || formData.productList.some(product => !product.productId)) {
            toast.error("Please select a product before adding the bill!");
            return;
        }
        const sanitizedProductList = formData.productList.map((product) => ({
            ...product,
            qty: product.qty === '' || product.qty === null || product.qty === undefined ? 0 : product.qty,
        }));
        const payload = {
            partyId: formData.partyId,
            taxType: formData.taxType,
            gstApply: formData.gstApply,
            invoiceType: formData.invoiceType,
            billNo: values.billNo,
            billDate: values.billDate,
            productList: sanitizedProductList,
            cDiscount: formData.cDiscount,
            remark: formData.remark,
            basicAmount: calculatedValues.basicAmount,
            discountAmount: calculatedValues.discountAmount,
            sgst: calculatedValues.sgst,
            cgst: calculatedValues.cgst,
            offerAmount: calculatedValues.offerAmount,
            roundingAmount: calculatedValues.roundingAmount,
            billAmount: calculatedValues.billAmount,
        }
        dispatch(addPurchaseBill(payload, limits)).then(() => {
            toggle();
            resetForm();
        });
    };

    const handleOtpManager = (values, { resetForm }) => {

        const payload = {
            otp: values.otp
        }
        dispatch(verifyOtp(payload)).then(() => {
            toggle();
            resetForm();
        });
    };

    const handleUpadteBill = (values) => {
        const payload = {
            partyId: formData.partyId,
            taxType: formData.taxType,
            gstApply: formData.gstApply,
            invoiceType: formData.invoiceType,
            billNo: values.billNo,
            billDate: values.billDate,
            productList: formData?.productList,
            cDiscount: formData.cDiscount,
            remark: formData.remark,
            basicAmount: formData.basicAmount,
            discountAmount: formData.discountAmount,
            sgst: formData.sgst,
            cgst: formData.cgst,
            offerAmount: formData.offerAmount,
            roundingAmount: formData.roundingAmount,
            billAmount: formData.billAmount,
        }

        dispatch(updatePurchaseBill(payload, limits, ids)).then(() => {
            setUpdateModal(false);
        });
    };

    const handleDeleteBill = () => {
        // setOtpModel(true)
        dispatch(deletePurchaseBill(ids, limits)).then(() => {
            deleteToggle();
            setMainPage(1);
        });
    };

    const handleSearch = (e) => {
        const newSearchQuery = e.target.value;
        setSearchQuery(newSearchQuery);
        const newSearchParams = {
            ...searchDefault,
            search: newSearchQuery || '',
            page: mainPage,
            limit: rowsPerPage
        };
        setSearchDefault(newSearchParams);
        dispatch(getPurchaseBill(newSearchParams));
    };

    const ChangeMainPage = (selected) => {
        setMainPage(parseInt(selected.selected) + 1);
        const updatedSearchParams = {
            ...searchDefault,
            search: searchQuery,
            page: parseInt(selected.selected) + 1,
            limit: rowsPerPage
        };
        setSearchDefault(updatedSearchParams);
        dispatch(getPurchaseBill(updatedSearchParams));
    };

    const handleRowsPerPageChange = (e) => {
        const newRowsPerPage = parseInt(e.target.value, 10);
        setRowsPerPage(newRowsPerPage);
        setMainPage(1);
    };

    const postPerPage = rowsPerPage;
    const PageCount = Math.ceil(
        billData?.getPurchaseBill?.data?.totalCount / postPerPage,
    );

    useEffect(() => {
        const updatedSearchParams = {
            ...searchDefault,
            search: searchQuery,
            page: mainPage,
            limit: rowsPerPage
        };
        dispatch(getPurchaseBill(updatedSearchParams));
        dispatch(productDropdown())
        dispatch(partyDropdown())
    }, [mainPage, rowsPerPage]);

    const handleView = (pId) => {
        dispatch(viewPurchaseBill(pId))
    }

    const formatDateForInput = (date) => {
        if (!date) return '';
        const formattedDate = new Date(date).toISOString().split('T')[0];
        return formattedDate;
    };

    const handleAddRow = () => {
        const newRow = {
            productName: '',
            productId: '',
            hsnCode: '',
            pack: '',
            mrp: '',
            gst: '',
            expDate: '',
            batchNo: '',
            qty: '',
            fQty: '',
            fn: '',
            pRate: '',
            discount: '',
            netRate: '',
            amount: '',
            inRate: '',
        };

        setFormData((prevState) => {
            const updatedProductList = [...prevState.productList, newRow];

            setTimeout(() => {
                const newRowIndex = updatedProductList.length - 1;
                if (dropdownRefs.current[newRowIndex]) {
                    dropdownRefs.current[newRowIndex].click();
                }
            }, 100);

            return {
                ...prevState,
                productList: updatedProductList,
            };
        });
    };

    const handleSearchChange = (e) => {
        setSearchProduct(e.target.value.toLowerCase());
    };

    const handleSearchParty = (e) => {
        setSearchParty(e.target.value.toLowerCase());
    };

    const filteredProducts = purchaseData?.productDropdown?.data?.productData?.filter((product) =>
        product.productName.toLowerCase().includes(searchProduct)
    );
    const filteredPartys = purchaseData?.partyDropdown?.data?.partyData?.filter((party) =>
        party.partyName.toLowerCase().includes(searchParty)
    );

    return (
        <>
            <div className="mt-[100px]">
                <div className="d-flex items-center gap-3">
                    <div className='w-[200px]'>
                        <label className="text-sm block mb-1">Date</label>
                        <input
                            type="date"
                            name="date"
                            className="w-75 outline-none !border-b"
                        />
                    </div>
                    <div className='w-[200px]'>
                        <label className="text-sm block mb-1">Start Date</label>
                        <input
                            type="date"
                            name="startDate"
                            className="w-75 outline-none !border-b"
                        />
                    </div>
                    <div className='w-[200px]'>
                        <label className="text-sm block mb-1">End Date</label>
                        <input
                            type="date"
                            name="endDate"
                            className="w-75 outline-none !border-b"
                        />
                    </div>
                    <div className="bg-white shadow-shadows py-[8px] px-[20px] rounded-full flex items-center ms-auto gap-2">
                        <IoSearchOutline />
                        <input
                            type="text"
                            name="search"
                            value={searchQuery}
                            onChange={handleSearch}
                            className="w-full outline-none"
                            placeholder="Search..."
                        />
                    </div>
                    <Button
                        onClick={toggle}
                        className="!bg-theme-dark fw-bold d-flex align-item-center border-0"
                    >
                        <IoMdAdd className="mt-1 gap-1" />
                        Add Bill
                    </Button>
                </div>
            </div>
            <div className="mt-[50px] mb-4">
                <div className='mb-3 flex items-center justify-between mt-5'>
                    <h3 className="fw-bold">Purchase Bill</h3>
                    <div className='ms-auto border-r me-3 pe-3'>Total Records: <span className='text-success underline underline-offset-2 ps-2'>{billData?.getPurchaseBill?.data?.totalCount || 0}</span></div>
                    <div>
                        Rows per page:
                        <select
                            value={rowsPerPage}
                            onChange={handleRowsPerPageChange}
                            className="ms-2 border rounded-md focus:outline-none"
                        >
                            <option value={10}>10</option>
                            <option value={30}>30</option>
                            <option value={50}>50</option>
                            <option value={100}>100</option>
                            <option value={500}>500</option>
                        </select>
                    </div>
                </div>
                <TableContainer>
                    <Table variant="striped" colorScheme="blackAlpha">
                        <Thead>
                            <Tr>
                                <Th>Bill Date</Th>
                                <Th>Party Name</Th>
                                <Th>Tax Type</Th>
                                <Th>GST Apply</Th>
                                <Th>Invoice Type</Th>
                                <Th>Bill No</Th>
                                <Th>Inward No</Th>
                                <Th>Basic Amount</Th>
                                <Th>SGST</Th>
                                <Th>CGST</Th>
                                <Th>Discount (%)</Th>
                                <Th>Discount Amount</Th>
                                <Th>Offer Amount</Th>
                                <Th>Rounding Amount</Th>
                                <Th>Bill Amount</Th>
                                <Th>Remark</Th>
                                <Th className="text-end sticky right-0 bg-white">Action</Th>
                            </Tr>
                        </Thead>
                        <Tbody>
                            {
                                billData?.getPurchaseBill?.data?.data?.length > 0 ? (
                                    billData?.getPurchaseBill?.data?.data?.map((res, index) => {
                                        return (
                                            <Tr key={index}>
                                                <Td className='min-w-[10px]'>{res.billDate ? new Date(res.billDate).toLocaleDateString('en-GB') : ''}</Td>
                                                <Td className='min-w-[10px] capitalize'>{res.partyName}</Td>
                                                <Td className='min-w-[10px]'>{res.taxType}</Td>
                                                <Td className='min-w-[10px]'>{res.gstApply}</Td>
                                                <Td className='min-w-[10px]'>{res.invoiceType}</Td>
                                                <Td className='min-w-[10px]'>{res.billNo}</Td>
                                                <Td className='min-w-[50px]'>{res.inwardNo}</Td>
                                                <Td className='min-w-[50px]'>{res.basicAmount}</Td>
                                                <Td className='min-w-[50px]'>{res.sgst}</Td>
                                                <Td className='min-w-[50px]'>{res.cgst}</Td>
                                                <Td className='min-w-[50px]'>{res.cDiscount || '-'}</Td>
                                                <Td className='min-w-[50px]'>{res.discountAmount || '-'}</Td>
                                                <Td className='min-w-[50px]'>{res.offerAmount || '-'}</Td>
                                                <Td className='min-w-[50px]'>{res.roundingAmount || '-'}</Td>
                                                <Td className='min-w-[50px]'>{res.billAmount}</Td>
                                                <Td className='min-w-[50px] capitalize'>{res.remark}</Td>
                                                <Td style={{ minWidth: '100px', position: 'sticky', right: '0', backgroundColor: 'white' }}>
                                                    <div className="d-flex gap-3 justify-end">
                                                        <VscTarget onClick={() => { viewToggle(); handleView(res._id) }} className="cursor-pointer text-primary fs-5" />
                                                        <FaEdit
                                                            onClick={() => {
                                                                updateToggle();
                                                                setFormData(res);
                                                                setIds(res._id);
                                                            }}
                                                            className="cursor-pointer border-green-color fs-5 text-success"
                                                            title="update"
                                                        />
                                                        <MdDelete
                                                            onClick={() => {
                                                                deleteToggle();
                                                                setIds(res._id)
                                                            }}
                                                            className="cursor-pointer border-green-color fs-5 text-danger"
                                                            title="delete"
                                                        />
                                                    </div>
                                                </Td>
                                            </Tr>
                                        )
                                    })
                                ) : (
                                    <Tr>
                                        <Td colSpan={29}>No any data</Td>
                                    </Tr>
                                )

                            }
                        </Tbody>
                    </Table>
                </TableContainer>
            </div>

            <ReactPaginate
                breakLabel="..."
                nextLabel="next >"
                onPageChange={ChangeMainPage}
                pageRangeDisplayed={5}
                pageCount={PageCount}
                previousLabel="< previous"
                renderOnZeroPageCount={null}
                className="pagination"
            />

            {/* add bill */}

            <Modal show={show} onHide={toggle} className='purchase_bill'>
                <Modal.Header closeButton>
                    <Modal.Title>Add Purchase Bill</Modal.Title>
                </Modal.Header>
                <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={handleAddBill}
                >
                    {({ handleSubmit, setFieldValue, values }) => (
                        <Form onSubmit={handleSubmit}>
                            <Modal.Body>
                                <div className="row">
                                    <div className="col-2">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Party Name</Form.Label>
                                            <Dropdown>
                                                <Dropdown.Toggle className='!text-gray-500 text-start w-full shadow-none focus:!border-theme-dark !border-[#dee2e6] py-[6px] px-[12px] bg-transparent'>
                                                    <span className='text-ellipsis block whitespace-nowrap overflow-hidden'>{formData.partyId ? purchaseData?.partyDropdown?.data?.partyData?.find(party => party._id === formData.partyId)?.partyName : 'Select Party Name'}</span>
                                                </Dropdown.Toggle>

                                                <Dropdown.Menu className='w-[300px]'>
                                                    <div className='text-sm m-1'>
                                                        <Form.Control
                                                            type="text"
                                                            as={Form.Control}
                                                            value={searchParty}
                                                            onChange={handleSearchParty}
                                                            placeholder='Search party'
                                                            className='!shadow-none !text-sm focus:!border-theme-dark outline-none focus:!bg-transparent'
                                                        />
                                                    </div>
                                                    {
                                                        filteredPartys?.length > 0 ? (
                                                            filteredPartys?.map((res) => {
                                                                return (
                                                                    <Dropdown.Item key={res._id} onClick={() => { handleDropdownChange('partyId', res._id); setFieldValue('partyId', res._id) }}>{res.partyName}</Dropdown.Item>
                                                                )
                                                            })
                                                        ) : (
                                                            <Dropdown.Item>No any data</Dropdown.Item>
                                                        )
                                                    }
                                                </Dropdown.Menu>
                                            </Dropdown>
                                            <ErrorMessage
                                                name="partyId"
                                                component="div"
                                                className="text-danger"
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-2">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Tax Type</Form.Label>
                                            <Dropdown>
                                                <Dropdown.Toggle className='w-full !text-gray-500 text-start shadow-none focus:!border-theme-dark !border-[#dee2e6] py-[6px] px-[12px] bg-transparent'>
                                                    {formData.taxType || 'Select Tax Type'}
                                                </Dropdown.Toggle>

                                                <Dropdown.Menu className='w-full'>
                                                    {['Inclusive', 'Exclusive'].map(type => (
                                                        <Dropdown.Item
                                                            key={type}
                                                            onClick={() => handleDropdownChange('taxType', type)}
                                                        >
                                                            {type}
                                                        </Dropdown.Item>
                                                    ))}
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </Form.Group>
                                    </div>
                                    <div className="col-2">
                                        <Form.Group className="mb-3">
                                            <Form.Label>GST Apply</Form.Label>
                                            <Dropdown>
                                                <Dropdown.Toggle className='w-full !text-gray-500 text-start shadow-none focus:!border-theme-dark !border-[#dee2e6] py-[6px] px-[12px] bg-transparent'>
                                                    {formData.gstApply || 'Select'}
                                                </Dropdown.Toggle>

                                                <Dropdown.Menu className='w-full'>
                                                    {['Yes', 'No'].map(option => (
                                                        <Dropdown.Item
                                                            key={option}
                                                            onClick={() => handleDropdownChange('gstApply', option)}
                                                        >
                                                            {option}
                                                        </Dropdown.Item>
                                                    ))}
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </Form.Group>
                                    </div>
                                    <div className="col-2">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Invoice Type</Form.Label>
                                            <Dropdown>
                                                <Dropdown.Toggle className='w-full !text-gray-500 text-start shadow-none focus:!border-theme-dark !border-[#dee2e6] py-[6px] px-[12px] bg-transparent' id="dropdown-basic">
                                                    {formData.invoiceType || 'Select'}
                                                </Dropdown.Toggle>

                                                <Dropdown.Menu className='w-full'>
                                                    {['Cash', 'Credit'].map(type => (
                                                        <Dropdown.Item
                                                            key={type}
                                                            onClick={() => handleDropdownChange('invoiceType', type)}
                                                        >
                                                            {type}
                                                        </Dropdown.Item>
                                                    ))}
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </Form.Group>
                                    </div>
                                    <div className="col-2">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Bill No</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="billNo"
                                                as={Form.Control}
                                                onChange={(e) =>
                                                    setFieldValue('billNo', e.target.value)
                                                }
                                                value={values.billNo}
                                                placeholder="Enter Bill No"
                                                className="shadow-none focus:!border-theme-dark"
                                            />
                                            <ErrorMessage
                                                name="billNo"
                                                component="div"
                                                className="text-danger"
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-2">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Bill Date</Form.Label>
                                            <Form.Control
                                                type="date"
                                                name="billDate"
                                                as={Form.Control}
                                                onChange={(e) =>
                                                    setFieldValue('billDate', e.target.value)
                                                }
                                                value={values.billDate}
                                                placeholder="Enter HSN Code"
                                                className="shadow-none focus:!border-theme-dark"
                                            />
                                            <ErrorMessage
                                                name="billDate"
                                                component="div"
                                                className="text-danger"
                                            />
                                        </Form.Group>
                                    </div>

                                    <div className='col-12'>
                                        <div onClick={handleAddRow} className='flex justify-end text-2xl text-danger my-3'><FiPlusCircle /></div>
                                        <table className='table table-bordered p-0 purchase_table'>
                                            <thead>
                                                <tr className='text-center text-sm'>
                                                    <th className='min-w-[200px]'>Product Name</th>
                                                    <th className='!min-w-[100px]'>HSN Code</th>
                                                    <th className='!min-w-[50px]'>Pack</th>
                                                    <th className='!min-w-[50px]'>Expire Date</th>
                                                    <th className='!min-w-[50px]'>Batch</th>
                                                    <th className='!min-w-[50px]'>MRP</th>
                                                    <th className='!min-w-[50px]'>Qty</th>
                                                    <th className='!min-w-[50px]'>Free Qty</th>
                                                    <th className='!min-w-[50px]'>F/N</th>
                                                    <th className='!min-w-[50px]'>P. Rate</th>
                                                    <th className='!min-w-[50px]'>CD (%)</th>
                                                    <th className='!min-w-[50px]'>Net Rate</th>
                                                    <th className='!min-w-[50px]'>Amount</th>
                                                    <th className='!min-w-[50px]'>InRate</th>
                                                    <th className='!min-w-[30px]'>GST (%)</th>
                                                    <th className='!min-w-[30px]'>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {formData.productList.map((product, index) => (
                                                    <tr className='text-sm align-middle'>
                                                        <td>
                                                            <Dropdown>
                                                                <Dropdown.Toggle ref={(el) => (dropdownRefs.current[index] = el)} className='w-full !text-gray-500 uppercase text-start !text-sm shadow-none border-0 p-0 h-[20px] bg-transparent' id="dropdown-basic">
                                                                    {product.productId ? purchaseData?.productDropdown?.data?.productData?.find(p => p._id === product.productId)?.productName : ''}
                                                                </Dropdown.Toggle>

                                                                <Dropdown.Menu className='w-[250px] h-[200px] overflow-y-auto p-2'>
                                                                    <div className='text-sm'>
                                                                        <Form.Control
                                                                            type="text"
                                                                            as={Form.Control}
                                                                            value={searchProduct}
                                                                            onChange={handleSearchChange}
                                                                            placeholder='Search product'
                                                                            className='!shadow-none !text-sm focus:!border-theme-dark outline-none focus:!bg-transparent'
                                                                        />
                                                                    </div>
                                                                    {
                                                                        filteredProducts?.length > 0 ? (
                                                                            filteredProducts?.map((res) => {
                                                                                return (
                                                                                    <Dropdown.Item className='text-sm uppercase' key={res._id} onClick={() => handleProductSelect(res, index)}>{res.productName}</Dropdown.Item>
                                                                                )
                                                                            })
                                                                        ) : (
                                                                            <Dropdown.Item>No any data</Dropdown.Item>
                                                                        )
                                                                    }
                                                                </Dropdown.Menu>
                                                            </Dropdown>
                                                        </td>
                                                        <td>
                                                            <Form.Control
                                                                type="text"
                                                                as={Form.Control}
                                                                value={product?.hsnCode}
                                                                className='border-0 p-0 shadow-none !text-sm outline-none'
                                                            />
                                                        </td>
                                                        <td>
                                                            <Form.Control
                                                                type="text"
                                                                as={Form.Control}
                                                                value={product?.pack}
                                                                className='border-0 p-0 uppercase shadow-none !text-sm outline-none'
                                                            />
                                                        </td>
                                                        <td>
                                                            <Form.Control
                                                                type="month"
                                                                name="expDate"
                                                                as={Form.Control}
                                                                ref={(el) => (inputRefs.current.expDate = el)}
                                                                onKeyDown={(e) => handleKeyDown("expDate", e)}
                                                                onChange={(e) => handleFieldChange('expDate', e.target.value, index)}
                                                                value={product?.expDate}
                                                                className='border-0 p-0 shadow-none !text-sm outline-none'
                                                            />
                                                        </td>
                                                        <td>
                                                            <Form.Control
                                                                type="text"
                                                                name="batchNo"
                                                                as={Form.Control}
                                                                ref={(el) => (inputRefs.current.batchNo = el)}
                                                                onKeyDown={(e) => handleKeyDown("batchNo", e)}
                                                                onChange={(e) => handleFieldChange('batchNo', e.target.value, index)}
                                                                value={product?.batchNo}
                                                                className='border-0 p-0 shadow-none !text-sm outline-none'
                                                            />
                                                        </td>
                                                        <td>
                                                            <Form.Control
                                                                type="text"
                                                                as={Form.Control}
                                                                ref={(el) => (inputRefs.current.mrp = el)}
                                                                onKeyDown={(e) => handleKeyDown("mrp", e)}
                                                                onChange={(e) => handleFieldChange('mrp', e.target.value, index)}
                                                                value={product?.mrp}
                                                                className='border-0 p-0 shadow-none !text-sm outline-none'
                                                            />
                                                        </td>
                                                        <td>
                                                            <Form.Control
                                                                type="text"
                                                                name="qty"
                                                                ref={(el) => (inputRefs.current.qty = el)}
                                                                onKeyDown={(e) => handleKeyDown("qty", e)}
                                                                data-index="0"
                                                                value={product?.qty || ''}
                                                                onChange={(e) => handleFieldChange('qty', e.target.value, index)}
                                                                className="border-0 p-0 shadow-none !text-sm outline-none"
                                                            />
                                                        </td>
                                                        <td>
                                                            <Form.Control
                                                                type="text"
                                                                name="fQty"
                                                                as={Form.Control}
                                                                ref={(el) => (inputRefs.current.fQty = el)}
                                                                onKeyDown={(e) => handleKeyDown("fQty", e)}
                                                                onChange={(e) => handleFieldChange('fQty', e.target.value, index)}
                                                                value={product?.fQty}
                                                                className='border-0 p-0 shadow-none !text-sm outline-none'
                                                            />
                                                        </td>
                                                        <td>
                                                            <Form.Control
                                                                type="text"
                                                                name="fn"
                                                                as={Form.Control}
                                                                ref={(el) => (inputRefs.current.fn = el)}
                                                                onKeyDown={(e) => handleKeyDown("fn", e)}
                                                                onChange={(e) => handleFieldChange('fn', e.target.value, index)}
                                                                value={product?.fn}
                                                                className='border-0 p-0 shadow-none !text-sm outline-none'
                                                            />
                                                        </td>
                                                        <td>
                                                            <Form.Control
                                                                type="text"
                                                                name="pRate"
                                                                ref={(el) => (inputRefs.current.pRate = el)}
                                                                onKeyDown={(e) => handleKeyDown("pRate", e)}
                                                                as={Form.Control}
                                                                onChange={(e) => handleFieldChange('pRate', e.target.value, index)}
                                                                value={product?.pRate}
                                                                className='border-0 p-0 shadow-none !text-sm outline-none'
                                                            />
                                                        </td>
                                                        <td>
                                                            <Form.Control
                                                                type="text"
                                                                name="discount"
                                                                ref={(el) => (inputRefs.current.discount = el)}
                                                                onKeyDown={(e) => handleKeyDown("discount", e)}
                                                                data-index="0"
                                                                value={product?.discount || ''}
                                                                onChange={(e) => handleFieldChange('discount', e.target.value, index)}
                                                                className="border-0 p-0 shadow-none !text-sm outline-none"
                                                            />
                                                        </td>
                                                        <td>
                                                            <Form.Control
                                                                type="text"
                                                                name="netRate"
                                                                readOnly
                                                                as={Form.Control}
                                                                value={product?.netRate}
                                                                className='border-0 p-0 shadow-none !text-sm outline-none'
                                                            />
                                                        </td>
                                                        <td>
                                                            <Form.Control
                                                                type="text"
                                                                name="amount"
                                                                readOnly
                                                                as={Form.Control}
                                                                value={product?.amount}
                                                                className='border-0 p-0 shadow-none !text-sm outline-none'
                                                            />
                                                        </td>
                                                        <td>
                                                            <Form.Control
                                                                type="text"
                                                                name="inRate"
                                                                readOnly={parseFloat(product?.qty) > 0}
                                                                as={Form.Control}
                                                                onChange={(e) => handleFieldChange('inRate', e.target.value, index)}
                                                                value={product?.inRate}
                                                                className='border-0 p-0 shadow-none !text-sm outline-none'
                                                            />
                                                        </td>
                                                        <td>
                                                            <Form.Control
                                                                type="text"
                                                                value={product?.gst}
                                                                className='border-0 p-0 shadow-none !text-sm outline-none'
                                                            />
                                                        </td>
                                                        <td className='min-w-[50px]' align='center' onClick={() => handleDeleteRow(index)}><MdOutlineDeleteOutline className='text-danger text-xl cursor-pointer' /></td>

                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>

                                    <div className='flex justify-between mt-4'>
                                        <div className='text-sm'>
                                            <div className='flex items-center gap-3 mb-2'>
                                                <div className='w-[100px]'>Remark</div>
                                                <div><Form.Control type="text" name='remark' value={formData.remark} onChange={(e) => { setFormData({ ...formData, remark: e.target.value }) }} className='!border-gray-300 p-1 shadow-none !text-sm outline-none' /></div>
                                            </div>
                                        </div>
                                        <table className='text-sm'>
                                            <tr>
                                                <td className='min-w-[200px]'>Basic Amount</td>
                                                <td></td>
                                                <td><Form.Control type="text" value={calculatedValues.basicAmount} readOnly className='!border-gray-300 p-1 shadow-none !text-sm outline-none' /></td>
                                            </tr>
                                            <tr>
                                                <td>SGST</td>
                                                <td></td>
                                                <td><Form.Control type="text" value={calculatedValues.sgst} readOnly className='!border-gray-300 p-1 shadow-none !text-sm outline-none' /></td>
                                            </tr>
                                            <tr>
                                                <td>CGST</td>
                                                <td></td>
                                                <td><Form.Control type="text" value={calculatedValues.cgst} readOnly className='!border-gray-300 p-1 shadow-none !text-sm outline-none' /></td>
                                            </tr>
                                            <tr>
                                                <td>Discount Amount (%)</td>
                                                <td>
                                                    <Form.Control
                                                        name='cDiscount'
                                                        value={formData.cDiscount}
                                                        type="text"
                                                        onChange={(e) => {
                                                            const discountPercentage = parseFloat(e.target.value) || 0;
                                                            setFormData((prevState) => {
                                                              const updatedFormData = { ...prevState, cDiscount: e.target.value };
                                                              calculateTotals(updatedFormData.productList || [], discountPercentage, parseFloat(prevState.offerAmount || 0));
                                                              return updatedFormData;
                                                            });
                                                          }}
                                                          
                                                        className='!border-gray-300 p-1 shadow-none !text-sm outline-none'
                                                    />
                                                </td>

                                                <td>
                                                    <div className='!border-gray-300 border-[1px] rounded p-1 shadow-none !text-sm outline-none'>{Number(calculatedValues?.discountAmount || '').toFixed(2)}</div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Offer Amount (₹)</td>
                                                <td>
                                                    <Form.Control
                                                        type="text"
                                                        name='offerAmount'
                                                        value={formData.offerAmount}
                                                        onChange={(e) => {
                                                            const offerAmount = parseFloat(e.target.value) || 0;
                                                            setFormData((prevState) => {
                                                              const updatedFormData = { ...prevState, offerAmount: e.target.value };
                                                              calculateTotals(prevState.productList || [], parseFloat(prevState.cDiscount || 0), offerAmount);
                                                              return updatedFormData;
                                                            });
                                                          }}
                                                           className='!border-gray-300 p-1 shadow-none !text-sm outline-none' />
                                                </td>
                                                <td>
                                                    <div className='!border-gray-300 border-[1px] rounded p-1 shadow-none !text-sm outline-none'>{Number(calculatedValues?.offerAmount || '').toFixed(2)}</div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Rounding Amount</td>
                                                <td></td>
                                                <td><Form.Control type="text" value={calculatedValues.roundingAmount || ''} readOnly className='!border-gray-300 p-1 shadow-none !text-sm outline-none' /></td>
                                            </tr>
                                            <tr>
                                                <td>Bill Amount</td>
                                                <td></td>
                                                <td><Form.Control type="text" value={calculatedValues.billAmount ? calculatedValues.billAmount : ''} className='!border-gray-300 p-1 shadow-none !text-sm outline-none' /></td>
                                            </tr>
                                        </table>
                                    </div>
                                </div>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button
                                    variant="secondary"
                                    onClick={toggle}
                                    className="px-4 bg-transparent border-[1px] text-black border-green-color"
                                >
                                    Close
                                </Button>
                                <Button
                                    type="submit"
                                    className="!bg-theme-dark border-0 px-4"
                                >
                                    Add
                                </Button>
                            </Modal.Footer>
                        </Form>
                    )}
                </Formik>
            </Modal>

            {/* update Bill */}

            <Modal show={updateModal} onHide={updateToggle} className='purchase_bill'>
                <Modal.Header closeButton>
                    <Modal.Title>Update Purchase Bill</Modal.Title>
                </Modal.Header>

                <Formik
                    enableReinitialize={true}
                    initialValues={formData}
                    validationSchema={validationSchema}
                    onSubmit={handleUpadteBill}
                >
                    {({ handleSubmit, setFieldValue, values }) => (
                        <Form onSubmit={handleSubmit}>
                            <Modal.Body>
                                <div className="row">
                                    <div className="col-2">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Party Name</Form.Label>
                                            <Dropdown>
                                                <Dropdown.Toggle className='w-full !text-gray-500 text-start shadow-none focus:!border-theme-dark !border-[#dee2e6] py-[6px] px-[12px] bg-transparent'>
                                                    {formData.partyId ? purchaseData?.partyDropdown?.data?.partyData?.find(party => party._id === formData.partyId)?.partyName : 'Select Party Name'}
                                                </Dropdown.Toggle>

                                                <Dropdown.Menu className='w-full'>
                                                    <div className='text-sm m-1'>
                                                        <Form.Control
                                                            type="text"
                                                            as={Form.Control}
                                                            value={searchParty}
                                                            onChange={handleSearchParty}
                                                            placeholder='Search party'
                                                            className='!shadow-none !text-sm focus:!border-theme-dark outline-none focus:!bg-transparent'
                                                        />
                                                    </div>
                                                    {
                                                        purchaseData?.partyDropdown?.data?.partyData?.length > 0 ? (
                                                            purchaseData?.partyDropdown?.data?.partyData?.map((res) => {
                                                                return (
                                                                    <Dropdown.Item key={res._id} onClick={() => { handleDropdownChange('partyId', res._id); setFieldValue('partyId', res._id) }}>{res.partyName}</Dropdown.Item>
                                                                )
                                                            })
                                                        ) : (
                                                            <Dropdown.Item>No any data</Dropdown.Item>
                                                        )
                                                    }
                                                </Dropdown.Menu>
                                            </Dropdown>
                                            <ErrorMessage
                                                name="partyId"
                                                component="div"
                                                className="text-danger"
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-2">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Tax Type</Form.Label>
                                            <Dropdown>
                                                <Dropdown.Toggle className='w-full !text-gray-500 text-start shadow-none focus:!border-theme-dark !border-[#dee2e6] py-[6px] px-[12px] bg-transparent'>
                                                    {formData.taxType || 'Select Tax Type'}
                                                </Dropdown.Toggle>

                                                <Dropdown.Menu className='w-full'>
                                                    {['Inclusive', 'Exclusive'].map(type => (
                                                        <Dropdown.Item
                                                            key={type}
                                                            onClick={() => handleDropdownChange('taxType', type)}
                                                        >
                                                            {type}
                                                        </Dropdown.Item>
                                                    ))}
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </Form.Group>
                                    </div>
                                    <div className="col-2">
                                        <Form.Group className="mb-3">
                                            <Form.Label>GST Apply</Form.Label>
                                            <Dropdown>
                                                <Dropdown.Toggle className='w-full !text-gray-500 text-start shadow-none focus:!border-theme-dark !border-[#dee2e6] py-[6px] px-[12px] bg-transparent'>
                                                    {formData.gstApply || 'Select'}
                                                </Dropdown.Toggle>

                                                <Dropdown.Menu className='w-full'>
                                                    {['Yes', 'No'].map(option => (
                                                        <Dropdown.Item
                                                            key={option}
                                                            onClick={() => handleDropdownChange('gstApply', option)}
                                                        >
                                                            {option}
                                                        </Dropdown.Item>
                                                    ))}
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </Form.Group>
                                    </div>
                                    <div className="col-2">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Invoice Type</Form.Label>
                                            <Dropdown>
                                                <Dropdown.Toggle className='w-full !text-gray-500 text-start shadow-none focus:!border-theme-dark !border-[#dee2e6] py-[6px] px-[12px] bg-transparent' id="dropdown-basic">
                                                    {formData.invoiceType || 'Select'}
                                                </Dropdown.Toggle>

                                                <Dropdown.Menu className='w-full'>
                                                    {['Cash', 'Credit'].map(type => (
                                                        <Dropdown.Item
                                                            key={type}
                                                            onClick={() => handleDropdownChange('invoiceType', type)}
                                                        >
                                                            {type}
                                                        </Dropdown.Item>
                                                    ))}
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </Form.Group>
                                    </div>
                                    <div className="col-2">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Bill No</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="billNo"
                                                as={Form.Control}
                                                onChange={(e) =>
                                                    setFieldValue('billNo', e.target.value)
                                                }
                                                value={values.billNo}
                                                placeholder="Enter Bill No"
                                                className="shadow-none focus:!border-theme-dark"
                                            />
                                            <ErrorMessage
                                                name="billNo"
                                                component="div"
                                                className="text-danger"
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-2">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Bill Date</Form.Label>
                                            <Form.Control
                                                type="date"
                                                name="billDate"
                                                as={Form.Control}
                                                onChange={(e) =>
                                                    setFieldValue('billDate', e.target.value)
                                                }
                                                value={formatDateForInput(values.billDate)}
                                                placeholder="Enter HSN Code"
                                                className="shadow-none focus:!border-theme-dark"
                                            />
                                            <ErrorMessage
                                                name="billDate"
                                                component="div"
                                                className="text-danger"
                                            />
                                        </Form.Group>
                                    </div>

                                    <div className='col-12'>
                                        <div onClick={handleAddRow} className='flex justify-end text-2xl text-danger my-3'><FiPlusCircle /></div>
                                        <table className='table table-bordered p-0 purchase_table'>
                                            <thead>
                                                <tr className='text-center text-sm'>
                                                    <th className='min-w-[200px]'>Product Name</th>
                                                    <th className='!min-w-[100px]'>HSN Code</th>
                                                    <th className='!min-w-[50px]'>Pack</th>
                                                    <th className='!min-w-[50px]'>MRP</th>
                                                    <th className='!min-w-[50px]'>Batch</th>
                                                    <th className='!min-w-[50px]'>Expire Date</th>
                                                    <th className='!min-w-[50px]'>F/N</th>
                                                    <th className='!min-w-[50px]'>Free Qty</th>
                                                    <th className='!min-w-[50px]'>P. Rate</th>
                                                    <th className='!min-w-[50px]'>CD (%)</th>
                                                    <th className='!min-w-[50px]'>Net Rate</th>
                                                    <th className='!min-w-[50px]'>Qty</th>
                                                    <th className='!min-w-[50px]'>Amount</th>
                                                    <th className='!min-w-[50px]'>InRate</th>
                                                    <th className='!min-w-[30px]'>GST (%)</th>
                                                    <th className='!min-w-[30px]'>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    formData?.productList?.length > 0 ? (
                                                        formData?.productList?.map((res, index) => {
                                                            return (
                                                                <tr className='text-sm align-middle'>
                                                                    <td>
                                                                        <Dropdown>
                                                                            <Dropdown.Toggle ref={(el) => (dropdownRefs.current[index] = el)} className='w-full !text-gray-500 uppercase text-start !text-sm shadow-none border-0 px-0 py-1 bg-transparent' id="dropdown-basic">
                                                                                {res?.productId
                                                                                    ? purchaseData?.productDropdown?.data?.productData?.find(p => p._id === res?.productId)?.productName
                                                                                    : ''}
                                                                            </Dropdown.Toggle>

                                                                            <Dropdown.Menu className='w-[250px] h-[200px] overflow-y-auto'>
                                                                                <div className='text-sm px-[16px] pt-1'>
                                                                                    <Form.Control
                                                                                        type="text"
                                                                                        as={Form.Control}
                                                                                        value={searchProduct}
                                                                                        onChange={handleSearchChange}
                                                                                        placeholder='Search product'
                                                                                        className='!shadow-none !text-sm focus:!border-theme-dark outline-none focus:!bg-transparent'
                                                                                    />
                                                                                </div>
                                                                                {
                                                                                    filteredProducts?.length > 0 ? (
                                                                                        filteredProducts?.map((res) => {
                                                                                            return (
                                                                                                <Dropdown.Item className='text-sm uppercase' key={res._id} onClick={() => handleProductSelect1(res, index)}>{res.productName}</Dropdown.Item>
                                                                                            )
                                                                                        })
                                                                                    ) : (
                                                                                        <Dropdown.Item>No any data</Dropdown.Item>
                                                                                    )
                                                                                }
                                                                            </Dropdown.Menu>
                                                                        </Dropdown>
                                                                    </td>
                                                                    <td>
                                                                        <Form.Control
                                                                            type="text"
                                                                            as={Form.Control}
                                                                            value={res?.hsnCode}
                                                                            className='border-0 p-0 shadow-none !text-sm outline-none'
                                                                        />
                                                                    </td>
                                                                    <td>
                                                                        <Form.Control
                                                                            type="text"
                                                                            as={Form.Control}
                                                                            value={res?.pack}
                                                                            className='border-0 p-0 shadow-none uppercase !text-sm outline-none'
                                                                        />
                                                                    </td>
                                                                    <td>
                                                                        <Form.Control
                                                                            type="text"
                                                                            as={Form.Control}
                                                                            value={res?.mrp}
                                                                            onChange={(e) => handleFieldChange1('mrp', e.target.value, index)}
                                                                            className='border-0 p-0 shadow-none !text-sm outline-none'
                                                                        />
                                                                    </td>
                                                                    <td>
                                                                        <Form.Control
                                                                            type="text"
                                                                            name="batchNo"
                                                                            as={Form.Control}
                                                                            onChange={(e) => handleFieldChange1('batchNo', e.target.value, index)}
                                                                            value={res?.batchNo}
                                                                            className='border-0 p-0 shadow-none uppercase !text-sm outline-none'
                                                                        />
                                                                    </td>
                                                                    <td>
                                                                        <Form.Control
                                                                            type="month"
                                                                            name="expDate"
                                                                            as={Form.Control}
                                                                            onChange={(e) => handleFieldChange1('expDate', e.target.value, index)}
                                                                            value={res?.expDate}
                                                                            className='border-0 p-0 shadow-none !text-sm outline-none'
                                                                        />
                                                                    </td>
                                                                    <td>
                                                                        <Form.Control
                                                                            type="text"
                                                                            name="fn"
                                                                            as={Form.Control}
                                                                            onChange={(e) => handleFieldChange1('fn', e.target.value, index)}
                                                                            value={res?.fn}
                                                                            className='border-0 p-0 shadow-none !text-sm outline-none'
                                                                        />
                                                                    </td>
                                                                    <td>
                                                                        <Form.Control
                                                                            type="text"
                                                                            name="fQty"
                                                                            as={Form.Control}
                                                                            onChange={(e) => handleFieldChange1('fQty', e.target.value, index)}
                                                                            value={res?.fQty}
                                                                            className='border-0 p-0 shadow-none !text-sm outline-none'
                                                                        />
                                                                    </td>
                                                                    <td>
                                                                        <Form.Control
                                                                            type="text"
                                                                            name="pRate"
                                                                            as={Form.Control}
                                                                            onChange={(e) => handleFieldChange1('pRate', e.target.value, index)}
                                                                            value={res?.pRate}
                                                                            className='border-0 p-0 shadow-none !text-sm outline-none'
                                                                        />
                                                                    </td>
                                                                    <td>
                                                                        <Form.Control
                                                                            type="text"
                                                                            name="discount"
                                                                            data-index="0"
                                                                            value={res?.discount || ''}
                                                                            onChange={(e) => handleFieldChange1('discount', e.target.value, index)}
                                                                            className="border-0 p-0 shadow-none !text-sm outline-none"
                                                                        />
                                                                    </td>
                                                                    <td>
                                                                        <Form.Control
                                                                            type="text"
                                                                            name="netRate"
                                                                            readOnly
                                                                            as={Form.Control}
                                                                            value={res?.netRate}
                                                                            className='border-0 p-0 shadow-none !text-sm outline-none'
                                                                        />
                                                                    </td>
                                                                    <td>
                                                                        <Form.Control
                                                                            type="text"
                                                                            name="qty"
                                                                            data-index="0"
                                                                            value={res?.qty || ''}
                                                                            onChange={(e) => handleFieldChange1('qty', e.target.value, index)}
                                                                            className="border-0 p-0 shadow-none !text-sm outline-none"
                                                                        />
                                                                    </td>
                                                                    <td>
                                                                        <Form.Control
                                                                            type="text"
                                                                            name="amount"
                                                                            readOnly
                                                                            as={Form.Control}
                                                                            value={res?.amount}
                                                                            className='border-0 p-0 shadow-none !text-sm outline-none'
                                                                        />
                                                                    </td>
                                                                    <td>
                                                                        <Form.Control
                                                                            type="text"
                                                                            name="inRate"
                                                                            readOnly={parseFloat(res?.qty) > 0}
                                                                            as={Form.Control}
                                                                            onChange={(e) => handleFieldChange1('inRate', e.target.value, index)}
                                                                            value={res?.inRate}
                                                                            className='border-0 p-0 shadow-none !text-sm outline-none'
                                                                        />
                                                                    </td>
                                                                    <td>
                                                                        <Form.Control
                                                                            type="text"
                                                                            name='gst'
                                                                            readOnly
                                                                            value={res?.gst}
                                                                            className='border-0 p-0 shadow-none !text-sm outline-none'
                                                                        />
                                                                    </td>
                                                                    <td>
                                                                        <td className='min-w-[50px]' align='center'><MdOutlineDeleteOutline onClick={() => handleDelete(index)} className='text-danger text-xl cursor-pointer' /></td>
                                                                    </td>
                                                                </tr>
                                                            )
                                                        })
                                                    ) : (
                                                        <tr>
                                                            <td>No any data</td>
                                                        </tr>
                                                    )
                                                }
                                            </tbody>
                                        </table>
                                    </div>

                                    <div className='flex justify-between mt-4'>
                                        <div className='text-sm'>
                                            <div className='flex items-center gap-3 mb-2'>
                                                <div className='w-[100px]'>Remark</div>
                                                <div><Form.Control type="text" name='remark' value={formData.remark} onChange={(e) => { setFormData({ ...formData, remark: e.target.value }) }} className='!border-gray-300 p-1 shadow-none !text-sm outline-none' /></div>
                                            </div>
                                        </div>
                                        <table className='text-sm'>
                                            <tr>
                                                <td className='min-w-[200px]'>Basic Amount</td>
                                                <td></td>
                                                <td><Form.Control type="text" value={formData.basicAmount} readOnly className='!border-gray-300 p-1 shadow-none !text-sm outline-none' /></td>
                                            </tr>
                                            <tr>
                                                <td>SGST</td>
                                                <td></td>
                                                <td><Form.Control type="text" value={formData.sgst} readOnly className='!border-gray-300 p-1 shadow-none !text-sm outline-none' /></td>
                                            </tr>
                                            <tr>
                                                <td>CGST</td>
                                                <td></td>
                                                <td><Form.Control type="text" value={formData.cgst} readOnly className='!border-gray-300 p-1 shadow-none !text-sm outline-none' /></td>
                                            </tr>
                                            <tr>
                                                <td>Discount Amount</td>
                                                <td>
                                                    <Form.Control
                                                        name='cDiscount'
                                                        value={formData.cDiscount}
                                                        type="text"
                                                        onChange={(e) => {
                                                            const discountPercentage = parseFloat(e.target.value) || 0;
                                                            setFormData((prevState) => {
                                                                const updatedFormData = { ...prevState, cDiscount: e.target.value };
                                                                calculateTotals(updatedFormData.productList, discountPercentage, parseFloat(prevState.offerAmount || 0));
                                                                return updatedFormData;
                                                            });
                                                        }}
                                                        className='!border-gray-300 p-1 shadow-none !text-sm outline-none'
                                                    />
                                                </td>

                                                <td>
                                                    <div className='!border-gray-300 border-[1px] rounded p-1 shadow-none !text-sm outline-none'>{Number(formData?.discountAmount || 0).toFixed(2)}</div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Offer Amount</td>
                                                <td>
                                                    <Form.Control
                                                        name="offerAmount"
                                                        value={formData.offerAmount || ""}
                                                        type="text"
                                                        onChange={(e) => {
                                                            const offerAmount = parseFloat(e.target.value) || 0;
                                                            setFormData((prevState) => {
                                                                const updatedFormData = { ...prevState, offerAmount: e.target.value };
                                                                calculateTotals(prevState.productList, parseFloat(prevState.cDiscount || 0), offerAmount);
                                                                return updatedFormData;
                                                            });
                                                        }}
                                                        className="!border-gray-300 p-1 shadow-none !text-sm outline-none"
                                                    />
                                                </td>
                                                <td> <Form.Control
                                                    type="text"
                                                    value={formData.offerAmount || "0.00"}
                                                    readOnly
                                                    className="!border-gray-300 p-1 shadow-none !text-sm outline-none"
                                                /></td>
                                            </tr>
                                            <tr>
                                                <td>Rounding Amount</td>
                                                <td></td>
                                                <td><Form.Control type="text" value={formData.roundingAmount || '0.00'} readOnly className='!border-gray-300 p-1 shadow-none !text-sm outline-none' /></td>
                                            </tr>
                                            <tr>
                                                <td>Bill Amount</td>
                                                <td></td>
                                                <td><Form.Control type="text" value={formData.billAmount ? formData.billAmount : '0.00'} className='!border-gray-300 p-1 shadow-none !text-sm outline-none' /></td>
                                            </tr>
                                        </table>
                                    </div>
                                </div>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button
                                    variant="secondary"
                                    onClick={updateToggle}
                                    className="px-4 bg-transparent border-[1px] text-black border-green-color"
                                >
                                    Close
                                </Button>
                                <Button type="submit" className="!bg-theme-dark border-0 px-4">
                                    Update
                                </Button>
                            </Modal.Footer>
                        </Form>
                    )}
                </Formik>
            </Modal>

            {/* delete Bill */}

            <Modal show={deleteModal} onHide={deleteToggle}>
                <Modal.Body className="p-5">
                    <div>
                        <PiWarningCircleBold className="text-7xl w-100 text-danger" />
                    </div>
                    <div className="text-center mt-4">
                        <h3>Are You Sure ?</h3>
                        <p className="text-md">
                            Do you really want to delete these records?
                        </p>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="secondary"
                        onClick={deleteToggle}
                        className="px-4 bg-transparent border-[1px] text-black border-green-color"
                    >
                        No
                    </Button>
                    <Button
                        type="submit"
                        className="bg-danger border-0 px-4"
                        onClick={handleDeleteBill}
                    >
                        Yes
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* otp verification */}

            <Modal show={otpModel} onHide={deleteOtpToggle}>
                <Formik
                    initialValues={{ otp: "" }}
                    validationSchema={validationOtpSchema}
                    onSubmit={handleOtpManager}
                >
                    {({ handleSubmit, setFieldValue, values }) => (
                        <Form onSubmit={handleSubmit}>
                            <Modal.Body className="p-5">
                                <div>
                                    <PiWarningCircleBold className="text-7xl w-100 text-danger" />
                                </div>
                                <div className="text-center mt-4">
                                    <h3>Please verify OTP</h3>
                                    <Form.Group className="mb-3">
                                        {/* <Form.Label>Bill No</Form.Label> */}
                                        <Form.Control
                                            type="text"
                                            name="otp"
                                            as={Form.Control}
                                            onChange={(e) =>
                                                setFieldValue('otp', e.target.value)
                                            }
                                            value={values.otp}
                                            placeholder="Enter OTP"
                                            className="shadow-none focus:!border-theme-dark"
                                        />
                                        <ErrorMessage
                                            name="otp"
                                            component="div"
                                            className="text-danger"
                                        />
                                    </Form.Group>
                                </div>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button
                                    type="submit"
                                    className="bg-danger border-0 px-4"
                                    onClick={handleDeleteBill}
                                >
                                    Submit
                                </Button>
                            </Modal.Footer>
                        </Form>
                    )}

                </Formik>

            </Modal>
            {/* View modal */}
            <Modal show={viewModal} onHide={viewToggle} size='xl'>
                <Modal.Header closeButton>
                    <Modal.Title>Product List</Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-5">
                    <div className='table-responsive'>
                        <table className='table table-bordered p-0'>
                            <thead>
                                <tr className='text-center text-sm'>
                                    <th className='min-w-[300px]'>Product Name</th>
                                    <th className='!min-w-[100px]'>HSN Code</th>
                                    <th className='!min-w-[100px]'>Pack</th>
                                    <th className='!min-w-[100px]'>MRP</th>
                                    <th className='!min-w-[100px]'>Batch</th>
                                    <th className='!min-w-[100px]'>Expire Date</th>
                                    <th className='!min-w-[100px]'>Qty</th>
                                    <th className='!min-w-[100px]'>F/N</th>
                                    <th className='!min-w-[100px]'>Free Qty</th>
                                    <th className='!min-w-[100px]'>P. Rate</th>
                                    <th className='!min-w-[100px]'>CD (%)</th>
                                    <th className='!min-w-[100px]'>Net Rate</th>
                                    <th className='!min-w-[100px]'>Amount</th>
                                    <th className='!min-w-[100px]'>InRate</th>
                                    <th className='!min-w-[100px]'>GST (%)</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    billData?.viewPurchaseBill?.data?.data?.productList?.length > 0 ? (
                                        billData?.viewPurchaseBill?.data?.data?.productList?.map((res) => {
                                            return (
                                                <tr>
                                                    <td className='uppercase'>{res.productName}</td>
                                                    <td>{res.hsnCode}</td>
                                                    <td className='uppercase'>{res.pack}</td>
                                                    <td>{res.mrp}</td>
                                                    <td>{res.batchNo}</td>
                                                    <td>{new Date(res?.expDate).toLocaleDateString('en-GB', { month: '2-digit', year: 'numeric' })}</td>
                                                    <td>{res.qty}</td>
                                                    <td>{res.fn}</td>
                                                    <td>{res.fQty}</td>
                                                    <td>{res.pRate}</td>
                                                    <td>{res.discount}</td>
                                                    <td>{res.netRate}</td>
                                                    <td>{res.amount}</td>
                                                    <td>{res.inRate}</td>
                                                    <td>{res.gst}</td>
                                                </tr>
                                            )
                                        })
                                    ) : (
                                        <tr>
                                            <td colSpan={14}>No any data</td>
                                        </tr>
                                    )
                                }
                            </tbody>
                        </table>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
}
